import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opacity-50 focus:opacity-80 hover:opacity-80 transition-all duration-100 ease-in-out transform focus:-translate-y-1 hover:-translate-y-1 md:focus:-translate-y-2 md:hover:-translate-y-2 filter focus:drop-shadow-lg hover:drop-shadow-lg md:focus:drop-shadow-xl md:hover:drop-shadow-xl focus:outline-none" }
const _hoisted_2 = ["src"]


export default /*#__PURE__*/_defineComponent({
  props: {
    img: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.img,
      class: "w-8 md:w-12 object-contain"
    }, null, 8, _hoisted_2)
  ]))
}
}

})